import { useEffect, useRef, useState } from "react";
import UserApiService from "../services/apiServices/UserApiService";

/**
 * Resolves a user's phone number by id, fetched once per userId. The actual
 * response-shape parsing lives in UserApiService.getUserPhoneById (shared
 * with useSellerContact) — this hook only owns the fetch-once/state wiring.
 * Returns null until resolved or on failure.
 */
export function useUserPhoneById(userId: string | undefined | null): string | null {
  const [phone, setPhone] = useState<string | null>(null);
  const fetchedForRef = useRef<string | null>(null);

  useEffect(() => {
    if (!userId || fetchedForRef.current === userId) return;
    fetchedForRef.current = userId;
    UserApiService.getUserPhoneById(userId)
      .then((fetched) => {
        if (fetched) setPhone(fetched);
      })
      .catch(() => {});
  }, [userId]);

  return phone;
}

export default useUserPhoneById;
